<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" color="primary" text) {{ buttonText }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid)
          v-row
            v-col(cols="12")
              div.d-flex.justify-center.py-12(v-if="loading")
                v-progress-circular(:size="50" color="primary" indeterminate)
              v-tabs(v-else v-model="tab" grow)
                v-tabs-slider(color="primary")
                v-tab(href="#players") {{ translations.headers.tabs.players }}
                v-tab(href="#matches") {{ translations.headers.tabs.matches }}
                v-tab-item(value="players")
                  v-data-table(
                    :headers="headerPlayers"
                    :items="players" 
                    :items-per-page="10"
                    :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
                    )
                    template(v-slot:body="{ items }")
                      tbody
                        tr(v-for="item,ind in items"  :key="'player'+ind")
                          td {{ item.name }}
                          td {{ item.team }}
                          td {{ item.role }}
                          td(colspan="1").text-right {{ item.value }}
                v-tab-item(value="matches")
                  v-data-table(
                    :headers="headerMatches"
                    :items="matches" 
                    :items-per-page="30"
                    :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
                    )
                    template(v-slot:body="{ items }")
                      tbody
                        tr(v-for="item,ind in items"  :key="'player'+ind")
                          td {{ item.date }}
                          td {{ item.teamhome }}
                          td {{ item.score }}
                          td {{ item.teamaway }}
                          td {{ item.state }}
</template>

<script>
  export default {
    name: "MatchsetInfoDialog",
    props: {
      buttonText: {
        type: String,
        default: 'Info'
      },
      title: {
        type: String,
        default: 'Info:'
      },
      loading: {
        type: Boolean,
        default: false,
      },
      info: {
        type: Object,
        default: function(){
          return {
            ap: [],
            am: [],
          }
        }
      }
    },
    data:() => ({
      dialog: false,
      tab: null,
    }),
    computed: {
      headerPlayers(){
        return [
          {
            text: this.translations.headers.playersTable.name,
            value: 'name'
          },
          {
            text: this.translations.headers.playersTable.team,
            value: 'team'
          },
          {
            text: this.translations.headers.playersTable.role,
            value: 'role'
          },
          {
            text: this.translations.headers.playersTable.value,
            value: 'value',
              align:'right'
          },
        ]
      },
      headerMatches(){
        return [
          {
            text: this.translations.headers.matchesTable.date,
            value: 'date'
          },
          {
            text: this.translations.headers.matchesTable.teamhome,
            value: 'teamhome'
          },
          {
            text: this.translations.headers.matchesTable.score,
            value: 'score'
          },
          {
            text: this.translations.headers.matchesTable.teamaway,
            value: 'teamaway'
          },
          {
            text: this.translations.headers.matchesTable.state,
            value: 'state'
          },
        ]
      },
      players(){
        const vm = this;
        if (this.info.ap != undefined){
          return this.info.ap.map(player =>{
            return {
              name: player._p.n,
              team: player.t.n,
              role: player.r != ''? vm.$t('back.role.'+ player.r) : '',
              value: this.currencyFormat(player.v, '€'),
            }
          });
        } else {
          return [];
        }
      },
      matches(){
        const vm = this;
        if (this.info.am != undefined){
          return this.info.am.map(match =>{
            return {
              date: vm.$moment(match.s).format('DD/MM/YYYY HH:mm'),
              teamhome: match.h.id.n,
              score: `${match.h.s} - ${match.a.s}`,
              teamaway: match.a.id.n,
              state: match.st != ''? vm.$t('back.status.'+ match.st) : '',
            }
          });
        } else {
          return [];
        }
      },
      translations() {
        return this.$t("components.MatchsetInfoDialog");
      },
    },
    watch: {
      dialog: function(val){
        if(val) {
          this.$emit('openMatchsetInfoDialog');
        }
      },
    },
  }
</script>

<style lang="sass">
</style>